import { FormConfig } from 'components/common/form/FormConfig';
import React, { useMemo } from 'react';
import i18n from 'i18n';
import { FormContent } from 'components/common/form/Form';

export const ChannelGroupReportForm: React.FC<{
  isEditing: boolean;
  agencyOptions: SelectOptions[];
  currencyOptions: SelectOptions[];
}> = ({ isEditing, agencyOptions, currencyOptions }) => {
  const reportFormConfig = useMemo(() => {
    const fieldsBuilder = new FormConfig.FieldsBuilder()
      .addFormikSwitch({
        label: i18n.t(
          'channelGroupForm.labels.salesChannelReportShowOverspend'
        ),
        name: 'addonFeatures.report.salesChannelReportShowOverspend'
      })
      .addFormikSelect({
        label: i18n.t('channelGroupForm.labels.derecognitionAgencyIds'),
        name: 'property.addonProps.derecognitionAgencyIds',
        simpleValue: true,
        isMulti: true,
        options: agencyOptions
      })
      .addFormikInput({
        label: i18n.t('channelGroupForm.labels.defaultMargin'),
        name: 'property.addonProps.defaultMargin',
        type: 'number',
        min: 0,
        max: 1,
        step: 0.01
      });
    if (isEditing) {
      fieldsBuilder.addFormikLabel({
        label: i18n.t('channelGroupForm.labels.currency'),
        name: 'property.addonProps.currency'
      });
    } else {
      fieldsBuilder.addFormikSelect({
        label: i18n.t('channelGroupForm.labels.currency'),
        name: 'property.addonProps.currency',
        simpleValue: true,
        isMulti: false,
        options: currencyOptions
      });
    }
    return new FormConfig.Builder()
      .addSection(
        new FormConfig.SectionBuilder(fieldsBuilder.build())
          .withTitle(i18n.t('channelGroups.titles.reportContent'))
          .build()
      )
      .build();
  }, [isEditing, agencyOptions, currencyOptions]);

  return <FormContent formConfig={reportFormConfig} />;
};
